import { Component } from '@angular/core';

@Component({
  selector: 'bdr-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent { }
